import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { Id, QltSlotAttendance, SsaStatus, SsaSubStatus } from '../types';

export interface SlotAttendanceParams {
  class: Id;
  indexDay: string;
  date: string;
}

export interface SlotAttendanceChange {
  id: string;
  status: SsaStatus;
  subStatus: SsaSubStatus;
  /** Required for the server's carry-forward cascade; without it that cascade matches nothing. */
  student?: string;
}

export interface SlotAttendanceUpdateManyPayload {
  listChanges: SlotAttendanceChange[];
  indexDay: string;
  date: string;
}

export const SlotAttendanceRepository = {
  ...Repository<QltSlotAttendance>(qltClient, '/slot-student-attendances'),
  // Use this identity tuple, never slot alone: make-up periods may have slot=null.
  list: (params: SlotAttendanceParams) =>
    qltClient
      .get('/slot-student-attendances', { params })
      .then((res) => res.data as QltSlotAttendance[]),
  updateMany: (data: SlotAttendanceUpdateManyPayload) =>
    qltClient.post('/slot-student-attendances/update-many', data).then((res) => res.data),
  updateOne: (id: string, data: Pick<SlotAttendanceChange, 'status' | 'subStatus'>) =>
    qltClient.put(`/slot-student-attendances/${id}`, data).then((res) => res.data),
};

export default SlotAttendanceRepository;
